import { navigate } from '../lib/router'
import { Card, TopBar } from '../ui/parts'

/** A reserved slot. Kept deliberately empty until we know what belongs in it. */
export function EmergencyScreen() {
  return (
    <div className="screen">
      <TopBar title="Emergency" onBack={() => navigate('/other')} />

      <div className="stack">
        <Card>
          <div style={{ textAlign: 'center', padding: '22px 6px' }}>
            <div style={{ fontWeight: 650, marginBottom: 6 }}>Nothing here yet</div>
            <div className="muted" style={{ fontSize: 14, lineHeight: 1.5 }}>
              This section is reserved. Contacts, documents and what to do in a hurry will
              live here.
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
